// @ts-strict-ignore
import React, { useState } from 'react';
import { QueryMultiMetricEntry, SelectorTypeDefinitions } from 'common/query-builder/query-entry-section/types';
import { MenuType, MultiMetricsSectionItem } from 'common/query-builder/query-block/multi-metrics-menu/types';
import { RowSelector } from 'iron/common/query-builder/query-entry-section/components/selector';
import { useFeatureFlag } from 'common/hooks/useFeatureFlag';
import { ProjectFeatureFlag } from 'common/report/constants';
import { useMetricEntries } from 'common/report/insights/contexts/metrics';
import { BaseEntryRow } from '../base';
import type { EntryRowProps } from '../types';
// eslint-disable-next-line import/no-cycle
import { helpers } from './helpers';
export function MultiMetricsEntryRow(props: EntryRowProps<QueryMultiMetricEntry>) {
  const [entryEl, setEntryEl] = useState<HTMLDivElement>(null);
  const hasFirstClassMetrics = useFeatureFlag(ProjectFeatureFlag.FirstClassMetrics);
  const hasMetricLevelDataGroups = useFeatureFlag(ProjectFeatureFlag.MetricLevelDataGroups);
  const {
    selectMetricItem
  } = useMetricEntries();
  const handleSelect = (item: MultiMetricsSectionItem) => {
    /** for the First Class Metrics project, selecting any type of metric from this menu will result in a new metric entry */
    if (hasFirstClassMetrics) {
      let dataGroupId = null;
      if (hasMetricLevelDataGroups) {
        var _props$sectionProps$e;
        // new entries get the same dataGroupId as the previous entry so we don't remove filters/breakdowns unnecessarily
        // (mismatched dataGroupIds can cause filters/breakdowns to be removed, see `sanitizeSelectionForDataGroups`)
        dataGroupId = ((_props$sectionProps$e = props.sectionProps.entries) === null || _props$sectionProps$e === void 0 || (_props$sectionProps$e = _props$sectionProps$e.at(-1)) === null || _props$sectionProps$e === void 0 ? void 0 : _props$sectionProps$e.dataGroupId) || null;
      }
      props.abortStage();
      selectMetricItem({
        dataGroupId,
        index: props.index,
        selectedItem: item
      });
      return;
    }
    helpers.handleRowSelect(props, item, null, {
      featureFlags: {
        [ProjectFeatureFlag.FirstClassMetrics]: hasFirstClassMetrics,
        [ProjectFeatureFlag.MetricLevelDataGroups]: hasMetricLevelDataGroups
      }
    });
  };
  const handleCreateInline = (menuType: MenuType) => {
    helpers.handleRowCreate(props, menuType, {
      featureFlags: {
        [ProjectFeatureFlag.FirstClassMetrics]: hasFirstClassMetrics,
        [ProjectFeatureFlag.MetricLevelDataGroups]: hasMetricLevelDataGroups
      }
    });
  };
  const selectorRenderer = () => <RowSelector {...props} contextPanelParentElement={entryEl} isPlaceholder selectorType={SelectorTypeDefinitions.Metrics} onSelect={sectionItem => handleSelect(sectionItem)} onCreate={(ev: {
    detail: {
      item: MenuType;
    };
  }) => handleCreateInline(ev.detail.item)} data-sentry-element="RowSelector" data-sentry-component="selectorRenderer" data-sentry-source-file="index.tsx" />;
  return <BaseEntryRow ref={setEntryEl} {...props} isPlaceholder={false} renderSelector={selectorRenderer} overflowControls={[]} entryIcon={null} data-sentry-element="BaseEntryRow" data-sentry-component="MultiMetricsEntryRow" data-sentry-source-file="index.tsx" />;
}